import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

const TermsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div
        className="container"
        style={{ paddingTop: "100px", paddingBottom: "50px" }}
      >
        <h1 className="text-center mb-4">{t("terms.title")}</h1>

        <p>{t("terms.intro")}</p>

        <h3 className="mt-5">{t("terms.acceptance.title")}</h3>
        <p>{t("terms.acceptance.description")}</p>

        <h3 className="mt-4">{t("terms.user_responsibilities.title")}</h3>
        <p>{t("terms.user_responsibilities.details1")}</p>
        <p>{t("terms.user_responsibilities.details2")}</p>

        <h3 className="mt-4">{t("terms.proper_use.title")}</h3>
        <p>{t("terms.proper_use.details1")}</p>
        <p>{t("terms.proper_use.details2")}</p>

        <h3 className="mt-4">{t("terms.business_responsibility.title")}</h3>
        <p>{t("terms.business_responsibility.details1")}</p>
        <p>{t("terms.business_responsibility.details2")}</p>
        <p>{t("terms.business_responsibility.details3")}</p>

        <h3 className="mt-4">{t("terms.service_availability.title")}</h3>
        <p>{t("terms.service_availability.details")}</p>

        <h3 className="mt-4">{t("terms.right_to_deny.title")}</h3>
        <p>{t("terms.right_to_deny.details")}</p>

        <h3 className="mt-4">{t("terms.privacy.title")}</h3>
        <p>{t("terms.privacy.details")}</p>
      </div>
      <Footer />
    </>
  );
};

export default TermsPage;
